import { Suspense } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import BlogDetailHero from '../components/BlogDetailHero';
import BlogDetailContent from '../components/BlogDetailContent';
import { useSEO } from '../../../utils/seo';

const SocialMediaBlog = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Sosyal Medyada Sigorta Acentesi Nasıl Büyür? - Sigorta360 Blog',
    description: 'Sigorta acenteleri için sosyal medya büyüme stratejileri. Platform seçimi, içerik stratejisi, etkileşim artırma ve reklam kampanyaları hakkında detaylı rehber.',
    keywords: 'sigorta sosyal medya, sigorta instagram, sigorta facebook, sosyal medya stratejisi, sigorta pazarlama',
    canonical: `${siteUrl}/akademi/sosyal-medyada-sigorta-acentesi-nasil-buyur`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: 'Sosyal Medyada Sigorta Acentesi Nasıl Büyür?',
      description: 'Sigorta acenteleri için sosyal medya büyüme stratejileri rehberi',
      author: {
        '@type': 'Organization',
        name: 'Sigorta360 Ekibi'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Sigorta360',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      },
      datePublished: '2025-01-15',
      dateModified: '2025-01-15',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${siteUrl}/akademi/sosyal-medyada-sigorta-acentesi-nasil-buyur`
      }
    }
  });

  const blogData = {
    title: 'Sosyal Medyada Sigorta Acentesi Nasıl Büyür?',
    category: 'Sosyal Medya',
    date: '15 Ocak 2025',
    readTime: '8 dk',
    author: 'Sigorota360 Ekibi',
    image: 'https://public.readdy.ai/ai/img_res/829cc2b650335a5e1153ddf396231de0.jpg',
    content: [
      {
        type: 'paragraph',
        text: 'Günümüzde sosyal medya, sigorta acenteleri için vazgeçilmez bir pazarlama kanalı haline geldi. Doğru stratejilerle sosyal medyayı kullanarak hem marka bilinirliğinizi artırabilir hem de potansiyel müşterilere ulaşabilirsiniz.',
      },
      {
        type: 'heading',
        text: '1. Doğru Platformları Seçin',
      },
      {
        type: 'paragraph',
        text: 'Her sosyal medya platformu farklı bir kitleye hitap eder. Sigorta acenteleri için en etkili platformlar genellikle Facebook, Instagram ve LinkedIn\'dir. Facebook ve Instagram, geniş kitlelere ulaşmak için idealken, LinkedIn profesyonel ağınızı genişletmek için mükemmeldir.',
      },
      {
        type: 'heading',
        text: '2. İçerik Stratejisi Oluşturun',
      },
      {
        type: 'paragraph',
        text: 'Düzenli ve kaliteli içerik paylaşımı, sosyal medya başarısının temelidir. Eğitici içerikler, müşteri hikayeleri, sigorta ipuçları ve sektör haberleri paylaşarak takipçilerinizle değerli bilgiler sunun. Görsel içeriklere ağırlık verin çünkü görseller metinlere göre çok daha fazla etkileşim alır.',
      },
      {
        type: 'heading',
        text: '3. Etkileşimi Artırın',
      },
      {
        type: 'paragraph',
        text: 'Takipçilerinizle aktif olarak etkileşim kurun. Yorumları yanıtlayın, sorulara cevap verin ve anketler düzenleyin. Canlı yayınlar yaparak müşterilerinizle birebir iletişim kurabilir, güven oluşturabilirsiniz.',
      },
      {
        type: 'heading',
        text: '4. Reklam Kampanyaları Yürütün',
      },
      {
        type: 'paragraph',
        text: 'Organik erişim önemli olsa da, hedefli reklam kampanyaları ile çok daha hızlı büyüyebilirsiniz. Facebook ve Instagram reklamları, demografik özelliklere, ilgi alanlarına ve davranışlara göre hedefleme yapmanıza olanak tanır.',
      },
      {
        type: 'heading',
        text: '5. Analiz ve Optimizasyon',
      },
      {
        type: 'paragraph',
        text: 'Sosyal medya performansınızı düzenli olarak analiz edin. Hangi içerikler daha fazla etkileşim alıyor? Hangi saatlerde paylaşım yapmak daha etkili? Bu verileri kullanarak stratejinizi sürekli optimize edin.',
      },
      {
        type: 'paragraph',
        text: 'Sosyal medyada başarılı olmak zaman ve tutarlılık gerektirir. Ancak doğru stratejilerle, sigorta acentenizi dijital dünyada güçlü bir marka haline getirebilirsiniz.',
      },
    ],
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        <BlogDetailHero data={blogData} />
        <BlogDetailContent data={blogData} />
        <Footer />
      </div>
    </Suspense>
  );
};

export default SocialMediaBlog;
